import { styled } from "styled-components";
import { device } from "../../styles/style";

export const Container = styled.div`
  width: 35vw;
  height: 90vh;
  background-color: #fff;
  position: fixed;
  right: 5%;
  top: 5%;
  border-radius: 5px;
  box-shadow: 0px 0px 4px 1px #849bbccc;

  @media ${device.mobileS} and ${device.mobileM} {
    right: 0;
    top: auto;
    width: 100%;
    bottom: 0;
    height: 35vh;
    font-size: 0.6rem;
  }

  @media ${device.mobileL} and ${device.tablet} {
    width: 100%;
    right: auto;
    top: auto;
    bottom: 0;
    height: 40vh;
  }

  @media ${device.laptop} and ${device.laptopMax} {
    width: 100%;
    right: auto;
    top: auto;
    bottom: 0;
    height: 40vh;
  }
`;

export const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  width: 100%;
  height: 40%;
  color: #fff;
  background-color: var(--secondaryBgColor);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px 5px 0 0;
  text-align: center;
  box-shadow: inset 0 -30px 10px -10px #fff;
`;

export const ContentEmpty = styled.div`
  padding: 30px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  h1 {
    padding-bottom: 20px;
  }
  p {
    overflow: auto;
    color: var(--opacityGrey);
  }

  @media ${device.mobileL} {
    padding: 10px 10px;
  }
  @media ${device.tablet} {
    padding: 20px 20px;
  }
`;

export const ContentDisplay = styled.div`
  overflow-y: auto;
  width: 100%;
  height: 60%;
  padding: 30px;

  img {
    max-width: 100%;
    height: auto;
  }
`;
